import { render } from "./AnwerbungEdit.vue?vue&type=template&id=208dfe43"
import script from "./AnwerbungEdit.vue?vue&type=script&lang=js"
export * from "./AnwerbungEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__